import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8qfvgpu7nc: FaireBrandEntity = {
  token: "b_8qfvgpu7nc",
  type: "brand",
  name: "OYOY LIVING DESIGN",
  avatarUrl:
    "https://cdn.faire.com/fastly/2a34c81bd28731e43e8e1b02a2b74fe93927e16af7916f3ed967c15816829524.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2a34c81bd28731e43e8e1b02a2b74fe93927e16af7916f3ed967c15816829524.jpeg",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 14,
  isTopShop: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
